import axios from 'axios';
import * as endpoints from './const';
import { forEach } from 'lodash';

class InsightApi {
  static getGenericInsightData(url) {
    return axios
      .get(`${endpoints.API_ROOT}${url}`)
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  static getGenericInsightDataFile(url) {
    axios({
      url: `${endpoints.API_ROOT}${url}`,
      method: 'GET',
      responseType: 'blob',
    }).then(response => {
      const fileName = response.headers['x-filename']
        ? response.headers['x-filename']
        : `ReportingPeriodExport.xlsx`;

      if (window.navigator && window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(response.data, fileName);
        return;
      }

      const contentType = response.headers['content-type']
        ? response.headers['content-type']
        : `text/plain`;

      const responseBlob = new Blob([response.data], { type: contentType });
      const url = window.URL.createObjectURL(responseBlob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    });
  }

  static getReportPeriods() {
    return axios
      .get(`${endpoints.FBT_REPORT_PERIODS}`)
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }

  static canCelTileData() {
    if (this.getTileDataRequests) {
      this.getTileDataRequests.forEach(request => {
        request.cancel('Operation canceled on unmount');
      });
    }
  }

  static getTileData(id, source, url) {
    const params = {
      companyCode: source.costcenter.value,
      countryCode: source.country.value,
    };

    if (source.restrictions && source.restrictions.length > 0) {
      params.restrictions = JSON.stringify(source.restrictions);
    }

    // save the new request for cancellation
    this.source = axios.CancelToken.source();
    if (!this.getTileDataRequests) this.getTileDataRequests = [];
    this.getTileDataRequests.push(this.source);

    const axConf = { cancelToken: this.source.token, params };

    return axios
      .get(`${endpoints.API_ROOT}${url}\\${id}`, axConf)
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        if (axios.isCancel(error)) {
          console.log('Request canceled', error.message);
        } else {
          throw error;
        }
      });
  }

  static getGraphData({ id, url, source, filter }) {
    const rootApi = endpoints.getAPIRoot();
    filter = filter || {};
    const params = {
      id,
      companyCode: source.costcenter.value,
      countryCode: source.country.value,
      startDate: filter.startDate,
      endDate: filter.endDate,
      categoryGroupFilter: filter.categoryGroupFilter,
    };

    if (source.restrictions && source.restrictions.length > 0) {
      params.restrictions = JSON.stringify(source.restrictions);
    }

    return (
      axios
        .get(`${rootApi}/${url}`, { params })
        // .get(`${rootApi}/insight/getGraphData`, { params })
        .then(response => response.data)
        .then(data => data.data)
        .catch(error => {
          throw error;
        })
    );
  }

  static sendGetTelematicsEmail(data) {
    return axios
      .post(endpoints.INSIGHT_SEND_GET_TELEMATICS_EMAIL, data)
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }

  static exportDocument(svg, options) {
    //  filter = filter || {};
    const data = new FormData();

    data.append('filename', 'chart');
    data.append('type', options.type);
    data.append('scale', options.scale);
    data.append('svg', svg);
    return axios
      .post(endpoints.INSIGHT_EXPORT_PDF_IMAGE, data, {
        responseType: 'arraybuffer',
      })
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  static exportGraphData({ id, source, filter }) {
    filter = filter || {};

    const params = {
      id,
      companyCode: source.costcenter.value,
      countryCode: source.country.value,
      startDate: filter.startDate,
      endDate: filter.endDate,
    };

    if (source.restrictions && source.restrictions.length > 0) {
      params.restrictions = JSON.stringify(source.restrictions);
    }

    return axios
      .get(endpoints.INSIGHT_EXPORT_GRAPH_DATA, {
        responseType: 'arraybuffer',
        params,
      })
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  static getGraphDetail(
    id,
    companyCode,
    countryCode,
    selectedFilters,
    restrictions
  ) {
    const queryParams = { id, companyCode, countryCode };
    forEach(selectedFilters || {}, (val, key) => {
      queryParams[key] = val;
    });

    if (restrictions && restrictions.length > 0) {
      queryParams.restrictions = JSON.stringify(restrictions);
    }

    return axios
      .get(endpoints.INSIGHT_GRAPH_DETAIL, {
        params: queryParams,
      })
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  static getFBTSummaryData() {
    return axios
      .get(endpoints.INSIGHT_FBTSUMMARY_REPORT)
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  static getSummaryDetail(paramdata) {
    return axios
      .post(endpoints.INSIGHT_SUMMARY_DETAIL, paramdata)
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  static getTotalTillDateByKey(graphId, companyCode, countryCode, filterKeyId) {
    return axios
      .get(
        `${endpoints.INSIGHT_TOTAL_TILL_DATE}?id=${graphId}&companyCode=${companyCode}&countryCode=${countryCode}&filterKeyId=${filterKeyId}`
      )
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  static getNotificationDetail(reportParams) {
    console.log(reportParams);
    return axios
      .get(endpoints.INSIGHT_NOTIFICATION_DETAIL, {
        params: reportParams,
      })
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  static getGraphFilters(params) {
    return axios
      .get(endpoints.INSIGHTS_GRAPH_FILTER, {
        params,
      })
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }
}

export default InsightApi;



// WEBPACK FOOTER //
// ./src/api/InsightsApi.js